import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { hasAuditMetadata } from "../auditLogPage.helpers";

interface AuditLogMetadataPopoverProps {
  metadata: Record<string, unknown> | null;
}

export function AuditLogMetadataPopover({ metadata }: AuditLogMetadataPopoverProps) {
  if (!hasAuditMetadata(metadata)) {
    return <span className="text-[12px] text-subtle">-</span>;
  }

  return (
    <Popover>
      <PopoverTrigger type="button" className="text-subtle hover:text-body">
        <Info size={14} />
      </PopoverTrigger>
      <PopoverContent className="w-72 space-y-1 text-[11px]">
        {Object.entries(metadata ?? {}).map(([key, value]) => (
          <div key={key} className="flex justify-between gap-2">
            <span className="text-muted-foreground">{key}</span>
            <span className="break-all text-right text-body">{String(value)}</span>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
